import { render, staticRenderFns } from "./home-header.vue?vue&type=template&id=e2af4870&scoped=true"
import script from "./home-header.vue?vue&type=script&lang=js"
export * from "./home-header.vue?vue&type=script&lang=js"
import style0 from "./home-header.vue?vue&type=style&index=0&id=e2af4870&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2af4870",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/.jenkins/workspace/web-douhua-mcn-pc/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e2af4870')) {
      api.createRecord('e2af4870', component.options)
    } else {
      api.reload('e2af4870', component.options)
    }
    module.hot.accept("./home-header.vue?vue&type=template&id=e2af4870&scoped=true", function () {
      api.rerender('e2af4870', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/home/components/home-header.vue"
export default component.exports